import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { colors, radii, space } from 'style/config';
import { wrapFunctionalComponent } from 'utils/framework';
import LanguageLocale from 'utils/LanguageLocale';
import DateUtils from 'utils/Date';
import { sanitizeHtml } from 'utils/sanitize';
import Empty from 'constants/empty';
import { Text } from 'components/ui';
import FlexIncentivesBannerEN from 'components/RichProfile/MyAccount/AutoReplenishment/FlexIncentivesBanner/locales/FlexIncentivesBanner_en_US';
import FlexIncentivesBannerFR from 'components/RichProfile/MyAccount/AutoReplenishment/FlexIncentivesBanner/locales/FlexIncentivesBanner_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocale;

const getText = getLocalisedDataFromResource(FlexIncentivesBannerEN, FlexIncentivesBannerFR);

/**
 * Displays a promotional banner for Flex Incentives showing the discount percent,
 * promo code, and validity date range for the active subscription incentive.
 */
function FlexIncentivesBanner({ flexIncentive, customCss = Empty.Object }) {
    const formatDate = useCallback(date => DateUtils.formatDateMDY(date, true, false, true), []);
    const { discountPercent, promoCode, startDate, endDate } = flexIncentive;

    return (
        <Text
            is='p'
            css={[styles.container, customCss.container]}
            dangerouslySetInnerHTML={{
                __html: getText('copy', [
                    sanitizeHtml(`${discountPercent}%`),
                    sanitizeHtml(promoCode),
                    sanitizeHtml(formatDate(startDate)),
                    sanitizeHtml(formatDate(endDate))
                ])
            }}
        />
    );
}

const styles = {
    container: {
        borderRadius: radii[2],
        backgroundColor: colors.nearWhite,
        padding: space[2]
    }
};

FlexIncentivesBanner.propTypes = {
    flexIncentive: PropTypes.shape({
        discountPercent: PropTypes.string.isRequired,
        promoCode: PropTypes.string.isRequired,
        startDate: PropTypes.string.isRequired,
        endDate: PropTypes.string.isRequired
    }).isRequired,
    customCss: PropTypes.shape({
        container: PropTypes.object
    })
};

export default wrapFunctionalComponent(FlexIncentivesBanner, 'FlexIncentivesBanner');
